import React from 'react';
import { render } from 'react-dom';
import App from './app';
import {
    trackInitialPageView,
    initDimensionsFromState,
} from '@eb/site-analytics';

// retrieve data from server to hydrate on the client
const props = window.__SERVER_DATA__ || {};

const root = document.getElementById('root');

render(<App {...props} />, root);

initDimensionsFromState(props);
trackInitialPageView(props.gaSettings);
